import React, { FC } from 'react';

import { CommonSizes } from 'src/components/common/CommonSizes';
import { UiGlobalLoadingIndicator } from 'src/components/UI/GlobalLoadingIndicator';
import { UiFullScreenLoader } from 'src/components/UI/loaders/FullScreenTransparent';
import { RouteTitle } from 'src/routes';
import { ChildrenPropType } from 'src/utils/types';

type Props = {
  children: ChildrenPropType;
  path: string | undefined;
};

export const LayoutMinimal: FC<Props> = ({ children, path }) => (
  <div id="body">
    <CommonSizes />
    <UiGlobalLoadingIndicator hasRoutes>
      <RouteTitle path={path} />

      <React.Suspense fallback={<UiFullScreenLoader transparent />}>{children}</React.Suspense>
    </UiGlobalLoadingIndicator>
  </div>
);
